export enum FORM_TYPES {
  TRIAL = 'Trial',
  DIRECTBUY = 'DirectBuy',
  BUSINESSTRIAL = 'LPBusinessTrial',
  PURCHASE = 'purchase',
  PARTNER = 'Partner',
}

export enum TRIAL_TYPES {
  BUSINESS = 'business',
  MSP = 'msp',
  TEAMS = 'teams',
  FAMILIES = 'families',
  PREMIUM = 'premium',
  ENTERPRISE = 'enterprise',
}

export enum MODAL_TYPES {
  CHEVY = 'Chevy',
  UNIFIED = 'Unified',
}
